import { delay, call, select, takeEvery, takeLatest, put, fork, all } from 'redux-saga/effects';
import * as common from '../sagasCommon';
import * as type from '../../constants/constant_saga_types';
import * as api from '../../services/item_number_type/api_item_number_type';
import * as apiCommon from '../../services/apiCommon';
import { ITEM_NUMBER_TYPE } from '../../constants/constant_doc_types';

export default function*(app) {
  try {
    yield all([
      fork(fetchListItemNumberTypeSaga, app),
      fork(fetchItemNumberTypeByIdSaga, app),
      fork(saveItemNumberTypeSaga, app),
      fork(deleteItemNumberTypeSaga, app),
    ]);
  } catch (e) {
    console.error('@saga_item_number_type: ', e.message || e.stack);
    throw e;
  }
}

function* callFetchListItemNumberType(feathersApp, action) {
  try {
    const { silent, filters } = action;
    yield common.showProgressListTable(silent);

    const dataParams = {
      filters,
      list_type: ITEM_NUMBER_TYPE,
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (e) {
    yield common.showErrorListTable(e);
  }
}

function* fetchListItemNumberTypeSaga(feathersApp) {
  yield takeLatest(
    type.FETCH_LIST_ITEM_NUMBER_TYPE,
    callFetchListItemNumberType,
    feathersApp
  );
}

function* callSaveItemNumberType(feathersApp, action) {
  try {
    yield common.showProgressSaveRecord();
    const { tenant, user } = yield select();

    const params = { tenant, user, data: action.data };
    const result = yield call(api.saveItemNumberType, feathersApp, params);
    yield common.doneSaveRecord(result, 'Item number type was saved');
    yield put({
      type: type.SIMPLE_FORM_SET_DATA,
      data: result,
    });
    yield callFetchListItemNumberType(feathersApp, { silent: true });
  } catch (e) {
    yield common.showErrorSaveRecord(e);
  }
}

function* saveItemNumberTypeSaga(feathersApp) {
  yield takeEvery(
    type.SAVE_ITEM_NUMBER_TYPE,
    callSaveItemNumberType,
    feathersApp
  );
}

function* callDeleteItemNumberType(feathersApp, action) {
  try {
    yield common.showProgressDeleteRecord();
    const { tenant, user } = yield select();
    const { id } = action;

    const params = { tenant, user, id };
    yield call(api.deleteItemNumberType, feathersApp, params);
    yield common.doneDeleteRecord(id, ITEM_NUMBER_TYPE);
    yield delay(2000);
    yield callFetchListItemNumberType(feathersApp, { silent: true });
  } catch (e) {
    yield common.showErrorDeleteRecord(e);
  }
}

function* deleteItemNumberTypeSaga(feathersApp) {
  yield takeEvery(
    type.DELETE_ITEM_NUMBER_TYPE,
    callDeleteItemNumberType,
    feathersApp
  );
}

function* callFetchItemNumberTypeById(feathersApp, action) {
  try {
    yield common.showProgressDataById();
    const { tenant, user } = yield select();
    const { id } = action;

    const params = { tenant, user, id };
    const result = yield call(api.fetchItemNumberTypeById, feathersApp, params);
    yield common.doneDataById(result);
    yield put({
      type: type.SIMPLE_FORM_SET_DATA,
      data: result,
    });
  } catch (e) {}
}

function* fetchItemNumberTypeByIdSaga(feathersApp) {
  yield takeEvery(
    type.FETCH_ITEM_NUMBER_TYPE_BY_ID,
    callFetchItemNumberTypeById,
    feathersApp
  );
}
